import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEenCameraByIdMutationVariables = Types.Exact<{
  input: Types.EenGetCameraByIdInput;
}>;


export type GetEenCameraByIdMutation = { __typename?: 'mutation_root', een_get_camera_by_id?: { __typename?: 'EenGetCameraByIdOutput', data: string } | null };


export const GetEenCameraByIdDocument = gql`
    mutation getEenCameraById($input: EenGetCameraByIdInput!) {
  een_get_camera_by_id(input: $input) {
    data
  }
}
    `;
export type GetEenCameraByIdMutationFn = Apollo.MutationFunction<GetEenCameraByIdMutation, GetEenCameraByIdMutationVariables>;

/**
 * __useGetEenCameraByIdMutation__
 *
 * To run a mutation, you first call `useGetEenCameraByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetEenCameraByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getEenCameraByIdMutation, { data, loading, error }] = useGetEenCameraByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEenCameraByIdMutation(baseOptions?: Apollo.MutationHookOptions<GetEenCameraByIdMutation, GetEenCameraByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetEenCameraByIdMutation, GetEenCameraByIdMutationVariables>(GetEenCameraByIdDocument, options);
      }
export type GetEenCameraByIdMutationHookResult = ReturnType<typeof useGetEenCameraByIdMutation>;
export type GetEenCameraByIdMutationResult = Apollo.MutationResult<GetEenCameraByIdMutation>;
export type GetEenCameraByIdMutationOptions = Apollo.BaseMutationOptions<GetEenCameraByIdMutation, GetEenCameraByIdMutationVariables>;